import { render } from "./todo-InjuryDevelopmentTrendAlysis.vue?vue&type=template&id=ca8a357c&scoped=true"
import script from "./todo-InjuryDevelopmentTrendAlysis.vue?vue&type=script&lang=js"
export * from "./todo-InjuryDevelopmentTrendAlysis.vue?vue&type=script&lang=js"

import "./todo-InjuryDevelopmentTrendAlysis.vue?vue&type=style&index=0&id=ca8a357c&lang=scss&scoped=true"
import "./todo-InjuryDevelopmentTrendAlysis.vue?vue&type=style&index=1&id=ca8a357c&lang=scss&scoped=true"
import "./todo-InjuryDevelopmentTrendAlysis.vue?vue&type=style&index=2&id=ca8a357c&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8a357c"]])

export default __exports__